import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';

// Mesmo fuso que o servidor usa nos filtros, relatorios e gatilhos por data (FazerAi::AccountTimeZone): o de
// relatorios da conta e, sem ele, Sao Paulo. Nunca o do navegador, para "hoje" ser o mesmo dia nos dois lados.
export const DEFAULT_ACCOUNT_TIME_ZONE = 'America/Sao_Paulo';

export const accountTimeZone = account =>
  account?.settings?.reporting_timezone || DEFAULT_ACCOUNT_TIME_ZONE;

// "YYYY-MM-DD" do dia corrente no fuso dado ("en-CA" escreve a data nesse formato).
export const todayIn = (timeZone, now = new Date()) =>
  new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(now);

export function useAccountTimeZone() {
  const { currentAccount } = useAccount();
  const timeZone = computed(() => accountTimeZone(currentAccount.value));
  const today = () => todayIn(timeZone.value);

  return { timeZone, today };
}
